import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"

import { computed, Ref, PropType, ref } from 'vue';
import { useRoute } from 'vue-router';

import { usePaginatedResponse } from '@/utils/query';
import { resume } from '@/plugins/resume';

import {
  useGetDeviceGroupsQuery,
  useGetDeviceGroupQuery,
} from '@/entities/device-group/hooks';

import { DeviceGroup } from '@/entities/device-group/types';

import {
  NkGroup,
  NkButtonLink,
  NkInlineModal,
  NkButton,
  NkEntry,
} from '@/core/components';

import DeviceGroupAdd from '@/entities/device-group/components/form/DeviceGroupAdd.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceGroupEntry',
  props: {
  parent: {
    type: Number as PropType<DeviceGroup['id']>,
    default: null,
  },
},
  setup(__props) {

const props = __props



const route = useRoute();
const page = ref(1);

const currentDeviceGroupData: Ref = computed(() => ({
  id: route.params.deviceGroup ? Number(route.params.deviceGroup) : null,
}));
const hasCurrentDeviceGroupId = computed(() => !!route.params.deviceGroup);
const { data: currentDeviceGroup } = useGetDeviceGroupQuery(currentDeviceGroupData, {
  enabled: hasCurrentDeviceGroupId,
});

const subDeviceGroupIds = computed(() => currentDeviceGroup.value?.subDeviceGroups || []);
const hasSubDeviceGroups = computed(() => !!subDeviceGroupIds.value.length);
const subDevicesQueryFilters = computed(() => ({
  ids: [...subDeviceGroupIds.value],
  page: page.value,
}));

const { data: deviceGroupsData, isLoading } = useGetDeviceGroupsQuery({
  enabled: hasSubDeviceGroups,
  refetchOnWindowFocus: false,
}, subDevicesQueryFilters, {
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'Accept': 'application/vnd.api+json',
  },
});
const { data: deviceGroups, meta } = usePaginatedResponse(deviceGroupsData);
// eslint-disable-next-line no-unsafe-optional-chaining
const isSinglePage = computed(() => !!(meta.value?.totalItems && meta.value?.itemsPerPage && (meta.value?.totalItems / meta.value?.itemsPerPage) <= 1));

const handlePageChange = (pageNumber: number) => {
  page.value = pageNumber;
};

return (_ctx: any,_cache: any) => {
  const _component_ElPagination = _resolveComponent("ElPagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(NkEntry), {
    title: _ctx.$t('misc.parks')
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_unref(NkGroup), { spacing: 5 }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceGroups), (deviceGroup) => {
            return (_openBlock(), _createBlock(_unref(NkButtonLink), {
              title: deviceGroup.name,
              to: {name: 'visionair-device-group', params: {
          deviceGroup: deviceGroup.id,
        }},
              key: deviceGroup.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(resume)(deviceGroup.name, 60)), 1)
              ]),
              _: 2
            }, 1032, ["title", "to"]))
          }), 128)),
          _createVNode(_unref(NkInlineModal), {
            title: _ctx.$t('device_group.form.title.add'),
            class: "max-w-screen-md"
          }, {
            content: _withCtx(({close}) => [
              _createVNode(DeviceGroupAdd, {
                parent: props.parent,
                onSubmitted: close
              }, null, 8, ["parent", "onSubmitted"])
            ]),
            default: _withCtx(() => [
              (_ctx.$store.getters['connection/isGranted'](['device_group_create']))
                ? (_openBlock(), _createBlock(_unref(NkButton), {
                    key: 0,
                    circle: "",
                    size: "sm",
                    icon: "NkPlus",
                    class: "text-white"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      })), [
        [_directive_loading, _unref(isLoading)]
      ]),
      (_unref(meta).totalItems && _unref(meta).itemsPerPage)
        ? (_openBlock(), _createBlock(_component_ElPagination, {
            key: 0,
            layout: "prev, pager, next",
            "hide-on-single-page": _unref(isSinglePage),
            total: _unref(meta).totalItems,
            "page-size": _unref(meta).itemsPerPage,
            onCurrentChange: handlePageChange
          }, null, 8, ["hide-on-single-page", "total", "page-size"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})